import T from "prop-types";
import styled, { ThemeProvider } from "styled-components";
import { withCms } from "@nested/react-with-cms";
import { H1, P, Link, SmartLink } from "@nested/ui";
import {
  theme as oldTheme,
  Container,
  Card,
  media,
} from "@nested/nested-react-components";

const Hero = styled.div`
  padding-top: 130px;
  padding-bottom: 50px;
  background-color: ${({ theme }) => theme.palette.blue.extraLight};
`;

const StyledCard = styled(Card)`
  text-align: center;
  margin-bottom: calc(${({ theme }) => theme.padding.base} * 2);
  & > img {
    margin-left: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }

  ${media.md`
    margin: 10px;
  `};
`;

export const CustomerStories = ({ stories = [] }) => (
  <ThemeProvider theme={oldTheme}>
    <div>
      <Hero>
        <H1 center>Customer stories</H1>
        <P center>Read stories from some of our happy home sellers.</P>
      </Hero>

      <Container section fixed row shouldWrap align="flex-start">
        {stories.map(({ url, mainImage, customer, quote }) => (
          <StyledCard size="small" key={url} align="center">
            <SmartLink to={`/customer-stories/${url}`}>
              <img
                src={`${mainImage}?w=300&auto=format&auto=compress`}
                alt=""
              />
            </SmartLink>
            <Link colour="mint" to={`/customer-stories/${url}`}>
              {`Read ${customer}`}
            </Link>
            <P center>
              <em>{quote}</em>
            </P>
          </StyledCard>
        ))}
      </Container>
    </div>
  </ThemeProvider>
);

CustomerStories.propTypes = {
  stories: T.arrayOf(
    T.shape({
      url: T.string.isRequired,
      mainImage: T.string.isRequired,
      customer: T.string.isRequired,
      quote: T.string.isRequired,
    }),
  ),
};

export const UniversalRender = withCms({
  template: "customer-stories",
})(CustomerStories);
